import { KitchenPricePdpCategoryStructure } from './category-card-section-types';
import { KITCHEN_PRICE_PDP_CDN_PATH } from '../../kitchen-price-pdp-constants';

export const KITCHEN_PRICE_PDP_BASE_CATEGORY_LIST: KitchenPricePdpCategoryStructure[] = [
  {
    name: 'Бытовая техника для кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/kitchen-appliances.png/kitchen-appliances.png`,
    alt: 'Бытовая техника для кухни',
    link: {
      href: '/catalogue/bytovaya-tehnika-dlya-kuhni/',
      title: 'Бытовая техника для кухни',
    },
  },
  {
    name: 'Мойки и\u00A0смесители для кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/sinks-and-faucets.png/sinks-and-faucets.png`,
    alt: 'Мойки и смесители для кухни',
    link: {
      href: '/catalogue/moyki-i-smesiteli-dlya-kuhni/',
      title: 'Мойки и смесители для кухни',
    },
  },
  {
    name: 'Кухонные столы и\u00A0стулья',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/tables-and-chairs.png/tables-and-chairs.png`,
    alt: 'Кухонные столы и стулья',
    link: {
      href: '/catalogue/stoly-i-stulya/',
      title: 'Столы и стулья',
    },
  },
  {
    name: 'Столешницы',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/tabletops.png/tabletops.png`,
    alt: 'Столешницы',
    link: {
      href: '/catalogue/stoleshnicy-i-komplektuyushchie/',
      title: 'Столешницы и комплектующие',
    },
  },
  {
    name: 'Стеновые панели',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/wall-panels.png/wall-panels.png`,
    alt: 'Стеновые панели',
    link: {
      href: '/catalogue/stenovye-paneli-dlya-kuhni/',
      title: 'Стеновые панели для кухни',
    },
  },
  {
    name: 'Выдвижные системы для кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/pull-out-systems.png/pull-out-systems.png`,
    alt: 'Выдвижные системы для кухни',
    link: {
      href: '/catalogue/vydvizhnye-korziny-i-butylochnicy/',
      title: 'Выдвижные системы для кухни',
    },
  },
  {
    name: 'Посуда',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/dishes.png/dishes.png`,
    alt: 'Посуда',
    link: {
      href: '/catalogue/posuda-dlya-servirovki/',
      title: 'Посуда для сервировки',
    },
  },
  {
    name: 'Барные стойки и\u00A0аксессуары',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/bar-counters-and-accessories.png/bar-counters-and-accessories.png`,
    alt: 'Барные стойки и аксессуары',
    link: {
      href: '/catalogue/barnye-stoyki-i-aksessuary/',
      title: 'Барные стойки и аксессуары',
    },
  },
];

export const KITCHEN_PRICE_PDP_CATALOG_CATEGORY_LIST: KitchenPricePdpCategoryStructure[] = [
  ...KITCHEN_PRICE_PDP_BASE_CATEGORY_LIST,
  {
    name: 'Модульные кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/modular-kitchens.png/modular-kitchens.png`,
    alt: 'Модульные кухни',
    link: {
      href: '/catalogue/modulnye-kuhni/',
      title: 'Модульные кухни',
    },
  },
  {
    name: 'Кухонные аксессуары',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/kitchen-accessories.png/kitchen-accessories.png`,
    alt: 'Кухонные аксессуары',
    link: {
      href: '/catalogue/kuhonnye-aksessuary/',
      title: 'Кухонные аксессуары',
    },
  },
  {
    name: 'Мебель для кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/kitchen-furniture.png/kitchen-furniture.png`,
    alt: 'Мебель для кухни',
    link: {
      href: '/catalogue/mebel-dlya-kuhni/',
      title: 'Мебель для кухни',
    },
  },
];

export const KITCHEN_PRICE_PDP_MODULAR_CATEGORY_LIST: KitchenPricePdpCategoryStructure[] = [
  ...KITCHEN_PRICE_PDP_BASE_CATEGORY_LIST,
  {
    name: 'Модульные кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/modular-kitchens.png/modular-kitchens.png`,
    alt: 'Модульные кухни',
    link: {
      href: '/proekt-kuhni/gotovye/',
      title: 'Готовые комплекты кухонь',
    },
  },
  {
    name: 'Кухонные аксессуары',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/kitchen-accessories.png/kitchen-accessories.png`,
    alt: 'Кухонные аксессуары',
    link: {
      href: '/catalogue/kuhonnye-aksessuary/',
      title: 'Кухонные аксессуары',
    },
  },
  {
    name: 'Мебель для кухни',
    imgSrc: `${KITCHEN_PRICE_PDP_CDN_PATH}/categories/kitchen-furniture.png/kitchen-furniture.png`,
    alt: 'Мебель для кухни',
    link: {
      href: '/catalogue/mebel-dlya-kuhni/',
      title: 'Мебель для кухни',
    },
  },
];
